/* ============================================================
   ILS - Homepage "Our customers say" carousel renderer (TASK-1973).
   Section: theme/sections/custom-reviews-home.liquid

   Reads window.ILS_REVIEWS_HOME = { apiBase, limit } and fills the
   rail inside [data-ils-revs-home] with real cards from
   GET {apiBase}/api/reviews/featured?limit={limit}.

   TASK-2050: the section is rendered with `hidden` by default and
   is only unhidden after a successful non-empty fetch. On fetch
   error or empty payload the whole section stays hidden — we no
   longer keep demo cards with fabricated names as a fallback.
   ============================================================ */
(function(){
  'use strict';

  /* Star SVG - same path as custom-reviews-page.js for visual parity. */
  var STAR_PATH = 'M12 2.6c.55 0 1.04.33 1.27.83l2.3 4.96 5.43.7c.55.07.99.45 1.16.97.16.51-.01 1.07-.42 1.43l-4.02 3.52 1.06 5.4c.1.54-.12 1.08-.57 1.4-.45.31-1.04.34-1.52.07L12 18.86l-4.69 2.61c-.48.27-1.07.24-1.52-.07-.45-.32-.67-.86-.57-1.4l1.06-5.4-4.02-3.52c-.41-.36-.58-.92-.42-1.43.17-.52.61-.9 1.16-.97l5.43-.7 2.3-4.96c.23-.5.72-.83 1.27-.83z';
  function starSvg(state){
    if(state === 'full'){
      return '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    }
    if(state === 'dim'){
      return '<svg viewBox="0 0 24 24" class="dim" aria-hidden="true"><path d="' + STAR_PATH + '"/></svg>';
    }
    var gid = 'hg' + Math.random().toString(36).slice(2, 8);
    return '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<defs><linearGradient id="' + gid + '"><stop offset="50%" stop-color="var(--star)"/><stop offset="50%" stop-color="var(--star-dim)"/></linearGradient></defs>' +
      '<path d="' + STAR_PATH + '" fill="url(#' + gid + ')"/></svg>';
  }
  function starsRow(rate){
    rate = parseFloat(rate) || 0;
    var html = '';
    for(var i = 1; i <= 5; i++){
      if(rate >= i)             html += starSvg('full');
      else if(rate >= i - 0.5)  html += starSvg('half');
      else                      html += starSvg('dim');
    }
    return '<span class="ils-stars">' + html + '</span>';
  }

  /* EU-27 flag SVGs - copied from custom-reviews-page.js. A little
     duplication is fine here vs. extracting a shared module right now. */
  var FLAGS = {
    DE:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#000"/><rect width="5" height="1" y="1" fill="#D00"/><rect width="5" height="1" y="2" fill="#FFCE00"/></svg>',
    LV:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="3" fill="#9E3039"/><rect width="5" height="1" y="1" fill="#fff"/></svg>',
    EE:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#0072CE"/><rect width="5" height="1" y="1" fill="#000"/><rect width="5" height="1" y="2" fill="#fff"/></svg>',
    LT:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#FDB913"/><rect width="5" height="1" y="1" fill="#006A44"/><rect width="5" height="1" y="2" fill="#C1272D"/></svg>',
    AT:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#ED2939"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#ED2939"/></svg>',
    BE:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#000"/><rect width="3" height="6" x="3" fill="#FAE042"/><rect width="3" height="6" x="6" fill="#ED2939"/></svg>',
    BG:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#fff"/><rect width="5" height="1" y="1" fill="#00966E"/><rect width="5" height="1" y="2" fill="#D62612"/></svg>',
    HR:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#FF0000"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#171796"/></svg>',
    CY:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="9" height="6" fill="#fff"/><path d="M3.7 2.2 L5.3 2.2 L5.3 2.9 L4.8 2.9 L4.8 3.4 L4.2 3.4 L4.2 2.9 L3.7 2.9 Z" fill="#D57800"/><path d="M3.5 4 L5.5 4" stroke="#4E5B31" stroke-width=".25"/></svg>',
    CZ:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="6" height="2" fill="#fff"/><rect width="6" height="2" y="2" fill="#D7141A"/><path d="M0 0 L3 2 L0 4 Z" fill="#11457E"/></svg>',
    DK:'<svg viewBox="0 0 37 28" preserveAspectRatio="none"><rect width="37" height="28" fill="#C8102E"/><rect width="37" height="4" y="12" fill="#fff"/><rect width="4" height="28" x="12" fill="#fff"/></svg>',
    FI:'<svg viewBox="0 0 18 11" preserveAspectRatio="none"><rect width="18" height="11" fill="#fff"/><rect width="3" height="11" x="5" fill="#003580"/><rect width="18" height="3" y="4" fill="#003580"/></svg>',
    FR:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#0055A4"/><rect width="3" height="6" x="3" fill="#fff"/><rect width="3" height="6" x="6" fill="#EF4135"/></svg>',
    GR:'<svg viewBox="0 0 27 18" preserveAspectRatio="none"><rect width="27" height="18" fill="#0D5EAF"/><rect width="27" height="2" y="2" fill="#fff"/><rect width="27" height="2" y="6" fill="#fff"/><rect width="27" height="2" y="10" fill="#fff"/><rect width="27" height="2" y="14" fill="#fff"/><rect width="10" height="10" fill="#0D5EAF"/><rect width="10" height="2" y="4" fill="#fff"/><rect width="2" height="10" x="4" fill="#fff"/></svg>',
    HU:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#CD2A3E"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#436F4D"/></svg>',
    IE:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#169B62"/><rect width="3" height="6" x="3" fill="#fff"/><rect width="3" height="6" x="6" fill="#FF883E"/></svg>',
    IT:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#009246"/><rect width="3" height="6" x="3" fill="#fff"/><rect width="3" height="6" x="6" fill="#CE2B37"/></svg>',
    LU:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#ED2939"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#00A1DE"/></svg>',
    MT:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="3" height="4" fill="#fff"/><rect width="3" height="4" x="3" fill="#CF142B"/></svg>',
    NL:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1" fill="#AE1C28"/><rect width="5" height="1" y="1" fill="#fff"/><rect width="5" height="1" y="2" fill="#21468B"/></svg>',
    PL:'<svg viewBox="0 0 5 3" preserveAspectRatio="none"><rect width="5" height="1.5" fill="#fff"/><rect width="5" height="1.5" y="1.5" fill="#DC143C"/></svg>',
    PT:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="9" height="6" fill="#FF0000"/><rect width="3.6" height="6" fill="#006600"/><circle cx="3.6" cy="3" r=".7" fill="#FFD700" stroke="#000" stroke-width=".08"/></svg>',
    RO:'<svg viewBox="0 0 9 6" preserveAspectRatio="none"><rect width="3" height="6" fill="#002B7F"/><rect width="3" height="6" x="3" fill="#FCD116"/><rect width="3" height="6" x="6" fill="#CE1126"/></svg>',
    SK:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="6" height="1.34" fill="#fff"/><rect width="6" height="1.34" y="1.34" fill="#0B4EA2"/><rect width="6" height="1.34" y="2.66" fill="#EE1C25"/></svg>',
    SI:'<svg viewBox="0 0 6 4" preserveAspectRatio="none"><rect width="6" height="1.34" fill="#fff"/><rect width="6" height="1.34" y="1.34" fill="#0000A5"/><rect width="6" height="1.34" y="2.66" fill="#ED1C24"/></svg>',
    ES:'<svg viewBox="0 0 10 7" preserveAspectRatio="none"><rect width="10" height="7" fill="#AA151B"/><rect width="10" height="3.5" y="1.75" fill="#F1BF00"/></svg>',
    SE:'<svg viewBox="0 0 18 11" preserveAspectRatio="none"><rect width="18" height="11" fill="#006AA7"/><rect width="2" height="11" x="5" fill="#FECC00"/><rect width="18" height="2" y="4.5" fill="#FECC00"/></svg>'
  };

  var VERIFIED_SVG =
    '<svg viewBox="0 0 24 24" aria-hidden="true">' +
      '<path d="M9 16.17L4.83 12l-1.42 1.41L9 19 21 7l-1.41-1.41z"/>' +
    '</svg>';

  /* Localized "verified" labels. English defaults; overridden in init() from
     the rail's data-verified-label / data-verified-review-label attributes
     emitted by custom-reviews-home.liquid via `| t` (TASK-2566). */
  var VERIFIED_WORD = 'verified';
  var VERIFIED_ARIA = 'Verified review';

  function escapeHtml(str){
    if(typeof str !== 'string') return '';
    return str.replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function formatDateDot(iso){
    if(!iso) return '';
    var parts = String(iso).split('-');
    if(parts.length !== 3) return iso;
    var dd = parts[2].length === 1 ? '0' + parts[2] : parts[2].slice(0, 2);
    var mm = parts[1].length === 1 ? '0' + parts[1] : parts[1];
    return dd + '.' + mm + '.' + parts[0];
  }

  /* If the URL has a width= query param, return a copy with width=1600 so the
     lightbox can show a larger version. Otherwise return the URL unchanged. */
  function largerPhotoUrl(url){
    if(typeof url !== 'string' || !url) return '';
    if(url.indexOf('width=') === -1) return url;
    return url.replace(/([?&])width=\d+/, '$1width=1600');
  }

  function buildCard(r){
    var photo = (Array.isArray(r.photos) && r.photos.length) ? r.photos[0] : '';
    var fullPhoto = largerPhotoUrl(photo);
    var photoHtml = photo
      ? '<img class="ils-rev__photo-img" src="' + escapeHtml(photo) + '" data-full="' + escapeHtml(fullPhoto) + '" alt="" loading="lazy">'
      : '';

    var name = escapeHtml(r.name || '');
    var surname = r.surname ? ' ' + escapeHtml(r.surname).charAt(0) + '.' : '';
    var country = (r.country || '').toUpperCase();
    var flagSvg = (country && FLAGS[country]) ? FLAGS[country] : '';
    var dateText = formatDateDot(r.date);
    var bodyText = escapeHtml(r.body || '');

    var html = '';
    html += '<article class="ils-rev" data-id="' + escapeHtml(String(r.id || '')) + '">';
    html +=   '<div class="ils-rev__photo">' + photoHtml + '</div>';
    html +=   '<div class="ils-rev__body">';
    html +=     '<div class="ils-rev__rating">';
    html +=       starsRow(r.rating);
    if(dateText){
      html +=     '<time class="ils-rev__date">' + escapeHtml(dateText) + '</time>';
    }
    html +=     '</div>';
    html +=     '<p class="ils-rev__text">' + bodyText + '</p>';
    html +=     '<div class="ils-rev__author">';
    if(flagSvg){
      html +=     '<span class="ils-rev__flag">' + flagSvg + '</span>';
    }
    html +=       '<span class="ils-rev__meta">';
    html +=         '<span class="ils-rev__name">' + name + surname + '</span>';
    html +=       '</span>';
    if(r.verified === true){
      html +=     '<span class="ils-rev__verified" aria-label="' + escapeHtml(VERIFIED_ARIA) + '">' +
                    VERIFIED_SVG + '<span>' + escapeHtml(VERIFIED_WORD) + '</span>' +
                  '</span>';
    }
    html +=     '</div>';
    html +=   '</div>';
    html += '</article>';
    return html;
  }

  /* Lightbox - lazily created on first open. One instance, reused.
     Shows the FULL photo (native aspect ratio, contained) on a dim backdrop.
     Dismiss: click backdrop, click close button, press Escape. */
  var lbEl = null;
  var lbImg = null;
  var lbPrevOverflow = '';

  function ensureLightbox(){
    if(lbEl) return;
    lbEl = document.createElement('div');
    lbEl.className = 'ils-revlb';
    lbEl.hidden = true;
    lbEl.innerHTML =
      '<button type="button" class="ils-revlb__close" aria-label="Close">' +
        '<svg viewBox="0 0 24 24" aria-hidden="true"><path d="M18.3 5.71 12 12.01l-6.3-6.3-1.4 1.4 6.29 6.3-6.3 6.3 1.42 1.4 6.3-6.3 6.29 6.3 1.42-1.4-6.3-6.3 6.29-6.3z"/></svg>' +
      '</button>' +
      '<img class="ils-revlb__img" src="" alt="">';
    lbImg = lbEl.querySelector('.ils-revlb__img');
    lbEl.addEventListener('click', function(e){
      if(e.target === lbEl) closeLightbox();
    });
    lbEl.querySelector('.ils-revlb__close').addEventListener('click', closeLightbox);
    document.addEventListener('keydown', function(e){
      if(!lbEl || lbEl.hidden) return;
      if(e.key === 'Escape' || e.keyCode === 27) closeLightbox();
    });
    document.body.appendChild(lbEl);
  }

  function openLightbox(url){
    if(!url) return;
    ensureLightbox();
    lbImg.src = url;
    lbEl.hidden = false;
    lbPrevOverflow = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
  }

  function closeLightbox(){
    if(!lbEl || lbEl.hidden) return;
    lbEl.hidden = true;
    document.body.style.overflow = lbPrevOverflow || '';
    if(lbImg) lbImg.src = '';
  }

  function attachLightboxTrigger(rail){
    rail.addEventListener('click', function(e){
      var img = e.target && e.target.closest ? e.target.closest('.ils-rev__photo-img') : null;
      if(!img || !rail.contains(img)) return;
      var url = img.getAttribute('data-full') || img.getAttribute('src') || '';
      if(!url) return;
      e.preventDefault();
      e.stopPropagation();
      openLightbox(url);
    });
  }

  function init(){
    var rail = document.querySelector('[data-ils-revs-home]');
    if(!rail) return;

    // Localized "verified" labels from the rail (TASK-2566); English fallback.
    VERIFIED_WORD = rail.getAttribute('data-verified-label') || VERIFIED_WORD;
    VERIFIED_ARIA = rail.getAttribute('data-verified-review-label') || VERIFIED_ARIA;

    var section = rail.closest('[data-ils-revs-home-sec]') || rail.closest('.ils-revs-sec');

    attachLightboxTrigger(rail);

    var cfg = window.ILS_REVIEWS_HOME || {};
    var apiBase = (typeof cfg.apiBase === 'string' && cfg.apiBase) ? cfg.apiBase.replace(/\/+$/, '') : '';
    var limit = (typeof cfg.limit === 'number' && cfg.limit > 0) ? cfg.limit : 12;
    if(!apiBase){
      if(window.console && console.warn) console.warn('[ils-revs-home] no apiBase configured - section stays hidden.');
      return;
    }

    var url = apiBase + '/api/reviews/featured?limit=' + encodeURIComponent(limit);

    fetch(url, { credentials: 'omit' })
      .then(function(r){
        if(!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      })
      .then(function(data){
        var list = (data && Array.isArray(data.reviews)) ? data.reviews : [];
        if(!list.length){
          if(window.console && console.warn) console.warn('[ils-revs-home] empty payload - section stays hidden.');
          return;
        }
        var html = '';
        for(var i = 0; i < list.length; i++){
          html += buildCard(list[i]);
        }
        rail.innerHTML = html;
        if(section) section.hidden = false;
      })
      .catch(function(err){
        if(window.console && console.warn) console.warn('[ils-revs-home] fetch failed - section stays hidden.', err);
      });
  }

  if(document.readyState !== 'loading'){
    init();
  } else {
    document.addEventListener('DOMContentLoaded', init);
  }
})();
